import {BaseAppEvent} from "../base-app-event";
import {APP} from "../../../core/app/consts";

export class BaseAnalyticsEvent extends BaseAppEvent {
  category: String;
  action: String;
  label: String;
  value: String;
  isUserDriven: Boolean;
  isSync: Boolean;

  constructor(value = '', label = '', action= '', category = 'web', isSync = false) {
    super();

    this.category = category;
    this.action = action;
    this.label = label;
    this.value = value;
    this.isUserDriven = false;
    this.isSync = isSync;
  }

  get isPopulated(): Boolean {
    return !!this.category && !!this.action;
  }

  get properties() : Object {
    return {}
  }

  get googleAnalyticsEvent() {
    return null;
  }

  resolveEventName(): String {
    return [this.category, this.action, this.label, this.value].filter(x => x).join('_');
  }

  get approvedProviders(): Array<String> {
    const providers: Array<String> = Object.values(APP.ANALYTICS.PROVIDERS);

    return providers;
  }
}
